import React, { useState } from "react";
import { Modal, Button, Image, Form, Spinner } from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import bathroomIcon from "../assets/img/bathroomIcon.png";
import homeIcon from "../assets/img/homeIcon.png";
import compliantIcon from "../assets/img/compliantIcon.png";
import interiordesignerIcon from "../assets/img/interior-designerIcon.png";
import paymentIcon from "../assets/img/paymentIcon.png";
import projectDescIcon from "../assets/img/projectDescIcon.png";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMinutes, setHours, setMinutes, isToday } from "date-fns";
import { ClickablePhoto, usePhotoLightbox } from "./PhotoLightbox";
import { revokePreviewUrls } from "../utils/photoPreview";

const OtherModal = ({ Other, OtherToggle, stepCompleteNext,loadBtn,selectedProject }) => {
  const [step, setStep] = useState(1);
  const [responses, setResponses] = useState({});
  const [selectedFile, setSelectedFile] = useState(null); // Store selected file
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateError, setDateError] = useState(false);
  const totalSteps = 5;
  const [file, setFile] = useState(null);
  const { openLightbox, closeLightbox } = usePhotoLightbox();


  const now = new Date();
  const minDateTime = addMinutes(now, 30); // Next 30 mins from now

  // Dynamically adjust minTime based on selectedDate
  const minTime = selectedDate && isToday(selectedDate) ? minDateTime : setHours(setMinutes(new Date(), 0), 0);
  const maxTime = setHours(setMinutes(new Date(), 59), 23); // End of the day

  const handleDateChange = (date) => {
    if (isToday(date)) {
      setSelectedDate(minDateTime); // Automatically set time to next 30 mins if today
    } else {
      setSelectedDate(date);
    }
  };
  const submitBtn = () => {
    stepCompleteNext(responses,file,description,selectedDate);
  }
  // Handle file upload preview
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setError("");
      setFile(file);
      setSelectedFile(URL.createObjectURL(file));
    }
  };
  const handleRemoveImage = () => {
    if (selectedFile) revokePreviewUrls([selectedFile]);
    setSelectedFile(null);
    setFile(null);
  };
const [error, setError] = useState("");
  const handleYesNoClick = (choice) => {
    console.log("step",step)
    console.log("choice",choice)
    setError("");
    var question = "";
  // if(step == 1) {
  //   question = "master";
  // }
  if(step == 1) {
    question = "architecturalplansordrawings";
  }
  if(step == 2) {
    question = "buildingpermit";
  }
  if(step == 3) {
    question = "workingwithdesigner";
  }
  if(step == 4) {
    question = "sellinghome";
  }
    setResponses((prev) => ({
      ...prev,
      [step]: choice,
      [question] : choice
    }));
  };

  
  // Handle "Next" step validation
  const handleNext = () => {
    setError("");
    if (step === 1 && responses[step] === "yes" && !file) {
      setError("Please upload a photo before proceeding.");
      return;
    }
    if (step === 5 && !description.trim()) {
      setDescriptionError(true);
    } else {
      setStep((prevStep) => prevStep + 1);
      setDescriptionError(false);
    }
  };

  return (
    <>
    <Modal show={Other} onHide={OtherToggle} centered className="modal-getstarted">
      <button
        type="button"
        className="rs-lc-close"
        onClick={OtherToggle}
        aria-label="Close"
      >
        <Icon icon="tabler:x" width={22} height={22} />
      </button>
      <Modal.Body className="text-center rs-lc-body">
        {/* Progress Bar */}
        <div className="peronalInfoProgress mb-4">
          {[...Array(totalSteps)].map((_, index) => (
            <span
              key={index}
              className={index < step ? "done" : ""}
              onClick={() => index + 1 < step && setStep(index + 1)}
              style={{ cursor: index + 1 < step ? "pointer" : "default" }}
            ></span>
          ))}
        </div>

        {/* Steps Content */}
        {[
          { text: "Do you have architectural plans or drawings?", icon: homeIcon },
          { text: "Do you already have a building permit?", icon: compliantIcon },
          { text: "Are you working with a designer?", icon: interiordesignerIcon },
          { text: "Will you be selling this home?", icon: paymentIcon },
          { text: "Provide a brief description of your project.", icon: projectDescIcon },
        ].map((item, index) => (
          <div key={index} className={`personalInfosteps ${step === index + 1 ? "d-block" : "d-none"}`}>
            <h4>Tell Us About Your Project</h4>
            <Image className="personalIcon" src={item.icon} alt="" />
            <h3>{item.text}</h3>

            {/* Yes/No Buttons */}
            {step !== 5 && (
              <div className="yesnobtn_box">
                <Link
                  className={`yesnobtn ${responses[step] === "yes" ? "active" : ""}`}
                  onClick={() => handleYesNoClick("yes")}
                >
                  Yes
                </Link>
                <Link
                  className={`yesnobtn ${responses[step] === "no" ? "active" : ""}`}
                  onClick={() => handleYesNoClick("no")}
                >
                  No
                </Link>
              </div>
            )}
            {error && <p className="text-danger">{error}</p>} 
            {/* File Upload Preview */}
            {step === 1 && responses[step] === "yes" && !selectedFile && (
              <div className="additional-div rs-re-upload-zone mt-2">
                <Form.Label htmlFor="uploadphotos">
                  <Icon icon="garden:upload-fill-16" width={24} height={24} />
                  <h6>Upload photos</h6>
                  <p className="mb-0">Drag and Drop files here</p>
                </Form.Label>
                <Form.Control type="file"  accept="image/png, image/jpeg" id="uploadphotos" className="d-none" onChange={handleFileChange} />

               
              </div>
            )}
             {step === 1 && responses[step] === "yes" && selectedFile  && ( 
             <div className="rs-re-preview-grid mt-4">
               <div className="preview-container uploadRemove_box rs-re-step-preview">
                 <ClickablePhoto
                   src={selectedFile}
                   alt="Architectural plan preview"
                   onView={openLightbox}
                 />
                 <button
                   type="button"
                   className="close-preview"
                   onClick={handleRemoveImage}
                   aria-label="Remove photo"
                 >
                   <Icon icon="tabler:x" width={18} height={18} />
                 </button>
               </div>
               <p className="rs-re-upload-confirm">Photo uploaded — click to view full size, or tap × to replace</p>
             </div>
             )}

            {/* Description Input */}
            {step === 5 && (
              selectedProject != "Consultation" ?
              <Form className="text-start mt-2">
                <Form.Group className="form-group">
                  <Form.Label>Write here</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    isInvalid={descriptionError}
                  />
                  <Form.Control.Feedback type="invalid">
                    Description is required.
                  </Form.Control.Feedback>
                </Form.Group>
              </Form>
              :
              <>
                <Form className="text-start mt-2">
                  <Form.Group className="form-group">
 <DatePicker
          selected={selectedDate}
          onChange={handleDateChange}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={30}
          dateFormat="yyyy-MM-dd h:mm aa"
          minDate={new Date()} // Prevent past dates
          minTime={minTime} // Set min time based on selected date
          maxTime={maxTime} // Set max time as end of the day
          className="form-control"
        />
        {dateError && (
          <div className="invalid-feedback">Please select a valid date and time.</div>
        )}
        </Form.Group>
        </Form>
        </>
            )}
            
          </div>
        ))}

        {/* Buttons */}
        <div className="d-flex align-items-center justify-content-center gap-2 flex-wrap mt-4">
          {step < totalSteps ? (
            <Link
              className="nextmodal_btn"
              onClick={handleNext}
              style={{ pointerEvents: responses[step] ? "auto" : "none", opacity: responses[step] ? 1 : 0.5 }}
            >
              Next <Icon icon="mynaui:arrow-right" width="24" height="24" />
            </Link>
          ) : (
            <Button 
              onClick={submitBtn}
              style={{ minWidth: 180 }}
              disabled={!(description.trim() || selectedDate) || loadBtn}
              >
              {loadBtn ?
               <Spinner color="#00316D" size={1} speed={1} animating={true} style={{marginTop:'10px'}} />
              :
              <>
              Submit <Icon icon="mynaui:arrow-right" width="24" height="24" />
              </>
              }
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
    </>
  );
};

export default OtherModal;
